// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card__extra-buttons svg{width:35px;cursor:pointer}.card__extra-buttons svg:not(:last-of-type){margin-right:10px}@media only screen and (max-width:340px){.card__extra-buttons svg{width:30px}}.card__extra-buttons .circle{fill:none;stroke:#9c9c9c}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
